import * as Actions from "../../actions/app"
import { toggleIdInArray } from "utils/toggle-id-in-array"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"

const initialState = {
  loading_existing_user_services_by_month_and_year: false,
  existing_user_services_by_month_and_year: [],

  loading_user_services_by_date: false,
  user_services_by_date: [],

  loading_user_services_by_status: false,
  user_services_by_status: [],

  saving_user_service_ids: [],
  saved_user_service_ids: [],

  rescheduling_user_service_ids: [],
  rescheduled_user_service_ids: [],

  canceling_user_service_ids: [],
  canceled_user_service_ids: [],

  removing_user_service_ids: [],
  removed_user_service_ids: [],

  executing_user_service_ids: [],
  executed_user_service_ids: [],

  loading_done_user_service_ids: [],
  done_user_service_ids: [],

  reverting_user_service_ids: [],
  reverted_user_service_ids: [],

  loading_customers_from_user_services: false,
  customers_from_user_services: []
}

const userServicesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_EXISTING_USER_SERVICES_BY_MONTH_AND_YEAR: {
      return {
        ...state,
        loading_existing_user_services_by_month_and_year: action.payload.loading,
        existing_user_services_by_month_and_year: action.payload.data ?? state.existing_user_services_by_month_and_year
      }
    }
    case Actions.GET_USER_SERVICES_BY_DATE: {
      return {
        ...state,
        loading_user_services_by_date: action.payload.loading,
        user_services_by_date: action.payload.data ?? state.user_services_by_date
      }
    }
    case Actions.GET_USER_SERVICES_BY_STATUS: {
      return {
        ...state,
        loading_user_services_by_status: action.payload.loading,
        user_services_by_status: action.payload.data ?? state.user_services_by_status
      }
    }
    case Actions.SAVE_USER_SERVICE: {
      return {
        ...state,
        saved_user_service_ids: toggleIdInArray(state.saved_user_service_ids, action.payload.saved_id),
        saving_user_service_ids: toggleIdInArray(state.saving_user_service_ids, action.payload.saving_id),
        user_services_by_date: addOrUpdateObjectInArray(state.user_services_by_date, action.payload.data, 'servicio_usuario_id'),
      }
    }
    case Actions.RESCHEDULE_USER_SERVICE: {
      return {
        ...state,
        rescheduled_user_service_ids: toggleIdInArray(state.rescheduled_user_service_ids, action.payload.rescheduled_id),
        rescheduling_user_service_ids: toggleIdInArray(state.rescheduling_user_service_ids, action.payload.rescheduling_id),
        user_services_by_date: addOrUpdateObjectInArray(state.user_services_by_date, action.payload.data, 'servicio_usuario_id'),
      }
    }
    case Actions.CANCEL_USER_SERVICE: {
      return {
        ...state,
        canceled_user_service_ids: toggleIdInArray(state.canceled_user_service_ids, action.payload.canceled_id),
        canceling_user_service_ids: toggleIdInArray(state.canceling_user_service_ids, action.payload.canceling_id),
        user_services_by_date: addOrUpdateObjectInArray(state.user_services_by_date, action.payload.data, 'servicio_usuario_id'),
      }
    }
    case Actions.REMOVE_USER_SERVICE: {
      return {
        ...state,
        removed_user_service_ids: toggleIdInArray(state.removed_user_service_ids, action.payload.removed_id),
        removing_user_service_ids: toggleIdInArray(state.removing_user_service_ids, action.payload.removing_id),
        user_services_by_date: state.user_services_by_date.filter(us => us.servicio_usuario_id !== action.payload.removed_id)
      }
    }
    case Actions.EXECUTE_USER_SERVICE: {
      return {
        ...state,
        executed_user_service_ids: toggleIdInArray(state.executed_user_service_ids, action.payload.executed_id),
        executing_user_service_ids: toggleIdInArray(state.executing_user_service_ids, action.payload.executing_id),
        user_services_by_date: addOrUpdateObjectInArray(state.user_services_by_date, action.payload.data, 'servicio_usuario_id'),
      }
    }
    case Actions.DONE_USER_SERVICE: {
      return {
        ...state,
        done_user_service_ids: toggleIdInArray(state.done_user_service_ids, action.payload.done_id),
        loading_done_user_service_ids: toggleIdInArray(state.loading_done_user_service_ids, action.payload.loading_id),
        user_services_by_date: addOrUpdateObjectInArray(state.user_services_by_date, action.payload.data, 'servicio_usuario_id'),
      }
    }
    case Actions.REVERT_USER_SERVICE: {
      return {
        ...state,
        reverting_user_service_ids: toggleIdInArray(state.reverting_user_service_ids, action.payload.reverting_id),
        reverted_user_service_ids: toggleIdInArray(state.reverted_user_service_ids, action.payload.reverted_id)
      }
    }
    case Actions.GET_CUSTOMERS_FROM_USER_SERVICES: {
      return {
        ...state,
        loading_customers_from_user_services: action.payload.loading,
        customers_from_user_services: action.payload.data ?? state.customers_from_user_services
      }
    }
    default: {
      return state
    }
  }
}
export default userServicesReducer
